<div *ngFor="let entry of blogEntries; let i = index">
    <app-entry [blogEntry]="entry"></app-entry>
</div>
